export const HEADERS = {
  assessmentType: "Assessment Type",
  assessmentName: "Assessment Name",
  assessmentNameMapping: "Assessment Name Mapping",
  overhead: "Overhead",
  commentsAssessment: "Assessment Comments",
  commentsCost: "Cost Comments",
  commentsClinicalStrategy: "Clinical Strategy Comments",
  commentsDataManagement: "Data Management Comments",
};

export const COUNTRY_HEADERS = (SOECountries) => [
  "Assessment Type",
  "Assessment Name",
  "Assessment Name Mapping",
  ...SOECountries.filter((soc) => soc.siteGroupId).map(
    (soc) => `${soc.siteGroupName} - ${soc.dropDownListLabel} - Assessment Cost`
  ),
];

export const ASSESSMENT_TYPES = [
  { name: "Procedure", value: "Procedure", isSiteCost: false },
  { name: "Non Procedure", value: "Non Procedure", isSiteCost: false },
  { name: "Site Cost 1x at Activation", value: "Site Cost 1x at Activation", isSiteCost: true },
  { name: "Site Cost 1x at Close", value: "Site Cost 1x at Close", isSiteCost: true },
  { name: "Site Cost Recurring Monthly", value: "Site Cost Recurring Monthly", isSiteCost: true },
  { name: "Site Cost Recurring Quarterly", value: "Site Cost Recurring Quarterly", isSiteCost: true },
  { name: "Site Cost Recurring Yearly", value: "Site Cost Recurring Yearly", isSiteCost: true },
  { name: "Site Cost Adhoc", value: "Site Cost Adhoc", isSiteCost: true },
  { name: "Participant Cost: Completed", value: "Participant Cost: Completed", isSiteCost: false },
  { name: "Participant Cost: Early Term", value: "Participant Cost: Early Term", isSiteCost: false },
  { name: "Participant Cost: Screen Fail", value: "Participant Cost: Screen Fail", isSiteCost: false },
  { name: "Participant Cost: Participant Invoiceable", value: "Participant Cost: Participant Invoiceable", isSiteCost: false },

];

export const SITE_ASSESSMENT_TYPES = ASSESSMENT_TYPES.filter((at) =>
  at.isSiteCost
).map((at) => at.value);

export const SITE_ASSESSMENT_NAMES = [
  "Study Close-Out Fees",
  "Monthly Recurring Fees",
  "Quarterly Recurring Fees",
  "Study Start-Up Fees",
  "Yearly Recurring Fees",
  "Ad Hoc Fees",
  "Completed Participant Fees",
  "Early Term Participant Fees",
  "Screen Fail Participant Fees",
  "Participant Invoiceable Fees",
];
